<template>
  <form class="flex flex-col gap-4" @submit.prevent="onSubmit">
    <div class="grid gap-4 md:grid-cols-2">
      <UInput
        v-model="form.name"
        type="text"
        placeholder="Name (optional)"
        autocomplete="name"
      />
      <UInput
        v-model="form.phone"
        type="tel"
        placeholder="Phone (optional)"
        autocomplete="tel"
      />
    </div>
    <UInput
      v-model="form.email"
      type="email"
      placeholder="E-mail"
      autocomplete="email"
      required
    />
    <UTextarea
      v-model="form.message"
      placeholder="Comment"
      :rows="6"
    />
    <div class="flex flex-wrap items-center gap-3">
      <UButton
        type="submit"
        variant="solid"
        color="secondary"
        trailing-icon="i-lucide-send"
        :loading="isSubmitting"
        :disabled="isSubmitting || !form.email"
      >
        Send message
      </UButton>
      <p v-if="statusMessage" class="text-sm text-workbook-orange">
        {{ statusMessage }}
      </p>
    </div>
  </form>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'

const form = reactive({
  name: '',
  phone: '',
  email: '',
  message: ''
})

const isSubmitting = ref(false)
const statusMessage = ref('')

async function onSubmit() {
  if (!form.email) {
    statusMessage.value = 'Please enter an e-mail address.'
    return
  }

  isSubmitting.value = true
  statusMessage.value = ''

  try {
    const response = await $fetch<{ ok: boolean; message?: string }>('/api/send-contact-mail', {
      method: 'POST',
      body: {
        name: form.name,
        phone: form.phone,
        email: form.email,
        message: form.message
      }
    })

    if (response.ok) {
      statusMessage.value = 'Thanks! Your message has been sent.'
      form.name = ''
      form.phone = ''
      form.email = ''
      form.message = ''
    } else {
      statusMessage.value = response.message || 'Something went wrong. Please try again.'
    }
  } catch (error: any) {
    statusMessage.value = error?.data?.message || error?.message || 'Something went wrong. Please try again.'
  } finally {
    isSubmitting.value = false
  }
}
</script>
